/**
 * Hero background images for the public marketing pages.
 *
 * Each public page gets a hero photo related to its topic. All images are
 * hotlinked from the Unsplash CDN. `auto=format` lets the CDN serve an
 * optimized JPEG/AVIF, and `fit=crop&w=1920` keeps the payload reasonable
 * for a full-width hero background.
 */

/** Landing page — students collaborating / campus life. */
export const HERO_LANDING =
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1920&q=80";

/** About page — HKU main building (brand origin / our campus). */
export const HERO_ABOUT =
  "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=1920&q=80";

/** Features page — event / crowd (events are the marquee feature). */
export const HERO_FEATURES =
  "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1920&q=80";

/** Universities page — university campus building. */
export const HERO_UNIVERSITIES =
  "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=1920&q=80";

/** Contact page — handshake / partnership. */
export const HERO_CONTACT =
  "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1920&q=80";